import styled from "styled-components";

const MainParagraph = styled.p`
	font-family: Source Sans, sans-serif;
	color: #f1f1f1;
	width: 60%;
	font-size: 3.2rem;
	font-weight: 300;
`;

export default MainParagraph;